import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

import Wrapper from '../../components/Wrapper/Wrapper'
import NavBar from '../../components/NavBar/NavBar'
import ArticleCard from '../../components/ArticleCard/ArticleCard'
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs'
import H1 from '../../components/H1/H1'

import shipImage from '../../images/blog-ship.png'
import shipImageMobile from '../../images/blog-ship-mobile.png'

import { windowWidthMobile } from '../../utils/consts'
import { getStorageWithExpiry } from '../../utils/getStorageWithExpiry'
import { setStorageWithExpiry } from '../../utils/setStorageWithExpiry'

import classes from './Blog.module.css'

const Blog = () => {
  const { t } = useTranslation()
  const breadcrumbScreenSectionRef = useRef(null)
  const blogRef = useRef(null)
  const [isWindowWidthMobile, setIsWindowWidthMobile] = useState(
    window.innerWidth <= windowWidthMobile
  )

  const onWindowWidthChange = () => {
    setIsWindowWidthMobile(window.innerWidth <= windowWidthMobile)
  }
  useEffect(() => {
    if (!getStorageWithExpiry('lang')) {
      setStorageWithExpiry('lang', 'ru', dayjs().add(1, 'years').format())
    } else {
      setStorageWithExpiry(
        'lang',
        `${getStorageWithExpiry('lang')}`,
        dayjs().add(1, 'years').format()
      )
    }
    window.addEventListener('resize', onWindowWidthChange)
    return () => window.removeEventListener('resize', onWindowWidthChange)
  }, [])

  return (
    <div>
      <NavBar />
      <Wrapper wrapperRef={blogRef}>
        <div
          className={`${classes['breadcrumbs_section']}`}
          id="blog"
          ref={breadcrumbScreenSectionRef}
        >
          <div className={`${classes['breadcrumbs']}`}>
            <Breadcrumbs
              breadcrumbs={[
                { label: t('breadcrumbs.home'), href: '/' },
                { label: t('breadcrumbs.blog') }
              ]}
            />
          </div>

          <div className={`${classes['breadcrumbs_imageWrapper']}`}>
            <img
              src={isWindowWidthMobile ? shipImageMobile : shipImage}
              alt={t('blog.shipAltText')}
              className={`${classes['breadcrumbs_imageWrappe-image']}`}
            />
          </div>
        </div>

        <H1 className={`${classes['blog_main-title']}`}>{t('blog.title')}</H1>

        <div className={`${classes['articles_section']}`}>
          <ArticleCard
            slug="perevalka-zerna-i-stoimost-frahta"
            source={t('blog.article.perevalka-zerna-i-stoimost-frahta.source')}
            date={t('blog.article.perevalka-zerna-i-stoimost-frahta.date')}
            title={t('blog.article.perevalka-zerna-i-stoimost-frahta.title')}
            description={t('blog.article.perevalka-zerna-i-stoimost-frahta.description')}
            buttonText={t('blog.article.perevalka-zerna-i-stoimost-frahta.button-text')}
            referer={t('blog.article.perevalka-zerna-i-stoimost-frahta.referer')}
            externalLink={true}
          />

          <ArticleCard
            slug="volatilnost-tarifov-na-morskoe-pogruzki-i-ee-prichiny"
            source={t('blog.article.volatilnost-tarifov-na-morskoe-pogruzki-i-ee-prichiny.source')}
            date={t('blog.article.volatilnost-tarifov-na-morskoe-pogruzki-i-ee-prichiny.date')}
            title={t('blog.article.volatilnost-tarifov-na-morskoe-pogruzki-i-ee-prichiny.title')}
            description={t(
              'blog.article.volatilnost-tarifov-na-morskoe-pogruzki-i-ee-prichiny.description'
            )}
            buttonText={t(
              'blog.article.volatilnost-tarifov-na-morskoe-pogruzki-i-ee-prichiny.button-text'
            )}
            referer={t(
              'blog.article.volatilnost-tarifov-na-morskoe-pogruzki-i-ee-prichiny.referer'
            )}
          />

          <ArticleCard
            slug="zerno-v-nestabilnosti"
            source={t('blog.article.zerno-v-nestabilnosti.source')}
            date={t('blog.article.zerno-v-nestabilnosti.date')}
            title={t('blog.article.zerno-v-nestabilnosti.title')}
            description=""
            buttonText={t('blog.article.zerno-v-nestabilnosti.button-text')}
            referer={t('blog.article.zerno-v-nestabilnosti.referer')}
          />

          <ArticleCard
            slug="zerno-padenie-pogruzki-na-rzhd-v-progressii"
            source={t('blog.article.zerno-padenie-pogruzki-na-rzhd-v-progressii.source')}
            date={t('blog.article.zerno-padenie-pogruzki-na-rzhd-v-progressii.date')}
            title={t('blog.article.zerno-padenie-pogruzki-na-rzhd-v-progressii.title')}
            description={t('blog.article.zerno-padenie-pogruzki-na-rzhd-v-progressii.description')}
            buttonText={t('blog.article.zerno-padenie-pogruzki-na-rzhd-v-progressii.button-text')}
            referer={t('blog.article.zerno-padenie-pogruzki-na-rzhd-v-progressii.referer')}
          />

          <ArticleCard
            slug="logisticheskie-itogi-i-prognozy"
            source={t('blog.article.logisticheskie-itogi-i-prognozy.source')}
            date={t('blog.article.logisticheskie-itogi-i-prognozy.date')}
            title={t('blog.article.logisticheskie-itogi-i-prognozy.title')}
            description={t('blog.article.logisticheskie-itogi-i-prognozy.description')}
            buttonText={t('blog.article.logisticheskie-itogi-i-prognozy.button-text')}
            referer={t('blog.article.logisticheskie-itogi-i-prognozy.referer')}
          />

          <ArticleCard
            slug="iz-za-potepleniya-v-situatsii-s-khusitami-v-suetskom-kanale-v-lineynykh-perevozkakh-tam-vozmozhny-za"
            source={t(
              'blog.article.iz-za-potepleniya-v-situatsii-s-khusitami-v-suetskom-kanale-v-lineynykh-perevozkakh-tam-vozmozhny-za.source'
            )}
            date={t(
              'blog.article.iz-za-potepleniya-v-situatsii-s-khusitami-v-suetskom-kanale-v-lineynykh-perevozkakh-tam-vozmozhny-za.date'
            )}
            title={t(
              'blog.article.iz-za-potepleniya-v-situatsii-s-khusitami-v-suetskom-kanale-v-lineynykh-perevozkakh-tam-vozmozhny-za.title'
            )}
            description=""
            buttonText={t(
              'blog.article.iz-za-potepleniya-v-situatsii-s-khusitami-v-suetskom-kanale-v-lineynykh-perevozkakh-tam-vozmozhny-za.button-text'
            )}
            referer={t(
              'blog.article.iz-za-potepleniya-v-situatsii-s-khusitami-v-suetskom-kanale-v-lineynykh-perevozkakh-tam-vozmozhny-za.referer'
            )}
          />

          <ArticleCard
            slug="zamedlenie-ekonomicheskogo-rosta-v-kitae-okazalo-znachitelnoe-vozdeystvie-na-morskie-perevozki"
            source={t(
              'blog.article.zamedlenie-ekonomicheskogo-rosta-v-kitae-okazalo-znachitelnoe-vozdeystvie-na-morskie-perevozki.source'
            )}
            date={t(
              'blog.article.zamedlenie-ekonomicheskogo-rosta-v-kitae-okazalo-znachitelnoe-vozdeystvie-na-morskie-perevozki.date'
            )}
            title={t(
              'blog.article.zamedlenie-ekonomicheskogo-rosta-v-kitae-okazalo-znachitelnoe-vozdeystvie-na-morskie-perevozki.title'
            )}
            description=""
            buttonText={t(
              'blog.article.zamedlenie-ekonomicheskogo-rosta-v-kitae-okazalo-znachitelnoe-vozdeystvie-na-morskie-perevozki.button-text'
            )}
            referer={t(
              'blog.article.zamedlenie-ekonomicheskogo-rosta-v-kitae-okazalo-znachitelnoe-vozdeystvie-na-morskie-perevozki.referer'
            )}
          />

          <ArticleCard
            slug="kak-exportirovat-tovary-morem"
            source={t('blog.article.kak-exportirovat-tovary-morem.source')}
            date={t('blog.article.kak-exportirovat-tovary-morem.date')}
            title={t('blog.article.kak-exportirovat-tovary-morem.title')}
            description={t('blog.article.kak-exportirovat-tovary-morem.description')}
            buttonText={t('blog.article.kak-exportirovat-tovary-morem.button-text')}
            referer={t('blog.article.kak-exportirovat-tovary-morem.referer')}
          />

          <ArticleCard
            slug="kurs-na-vostok-vozmozhnosti-i-riski-morskikh-gruzoperevozok"
            source={t(
              'blog.article.kurs-na-vostok-vozmozhnosti-i-riski-morskikh-gruzoperevozok.source'
            )}
            date={t(
              'blog.article.kurs-na-vostok-vozmozhnosti-i-riski-morskikh-gruzoperevozok.date'
            )}
            title={t(
              'blog.article.kurs-na-vostok-vozmozhnosti-i-riski-morskikh-gruzoperevozok.title'
            )}
            description={t(
              'blog.article.kurs-na-vostok-vozmozhnosti-i-riski-morskikh-gruzoperevozok.description'
            )}
            buttonText={t(
              'blog.article.kurs-na-vostok-vozmozhnosti-i-riski-morskikh-gruzoperevozok.button-text'
            )}
            referer={t(
              'blog.article.kurs-na-vostok-vozmozhnosti-i-riski-morskikh-gruzoperevozok.referer'
            )}
          />

          <ArticleCard
            slug="ugol-poluchil-pinkom-pod-zapad-mintrans-tolkaet-rzhd-k-subsidiyam-perevozok-tvyordogo"
            source={t(
              'blog.article.ugol-poluchil-pinkom-pod-zapad-mintrans-tolkaet-rzhd-k-subsidiyam-perevozok-tvyordogo.source'
            )}
            date={t(
              'blog.article.ugol-poluchil-pinkom-pod-zapad-mintrans-tolkaet-rzhd-k-subsidiyam-perevozok-tvyordogo.date'
            )}
            title={t(
              'blog.article.ugol-poluchil-pinkom-pod-zapad-mintrans-tolkaet-rzhd-k-subsidiyam-perevozok-tvyordogo.title'
            )}
            description=""
            buttonText={t(
              'blog.article.ugol-poluchil-pinkom-pod-zapad-mintrans-tolkaet-rzhd-k-subsidiyam-perevozok-tvyordogo.button-text'
            )}
            referer={t(
              'blog.article.ugol-poluchil-pinkom-pod-zapad-mintrans-tolkaet-rzhd-k-subsidiyam-perevozok-tvyordogo.referer'
            )}
          />
        </div>
      </Wrapper>
    </div>
  )
}

export default Blog
